import { Injectable } from '@angular/core';
import { RegPatService } from '../../../pricing/reg-pat-service/reg-pat-service';
import { HttpGeneralService } from '../../../shared';
import { CONFIG } from '../../../shared/config';
const DoneWait = CONFIG.baseUrls.ordering;

@Injectable({
  providedIn: 'root'
})
export class DoneWaitServiceService {

  constructor(private _httpGeneral: HttpGeneralService) { }

  getDoneWaitService(obj: any) {
    return this._httpGeneral.post(obj, `${DoneWait}/getDoneWaitService`);
  }

  updateServiceDeliveyStatus(obj: RegPatService) {
    return this._httpGeneral.post(obj, `${DoneWait}/UpdateServiceDeliveyStatus`);
  }
}
